module.exports = __webpack_public_path__ + "img/jp.326b928c.png";